/**
 * SuperAdmin Router Component
 * Handles routing for SuperAdmin section. Only Super Admin role may access.
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RBACService } from '../../utils/rbac';
import SuperAdminDashboard from '../../pages/SuperAdminDashboard';
import CompanyDetails from '../../pages/CompanyDetails';
import AddCompany from '../../pages/AddCompany';
import SuperAdminAnalytics from '../../pages/SuperAdminAnalytics';
import SuperAdminSettings from '../../pages/SuperAdminSettings';

const SUPER_ADMIN_ROLE = 'super admin';

const SuperAdminRouter: React.FC = () => {
  const user = RBACService.getCurrentUser();
  const isSuperAdmin = user?.roleName?.toLowerCase() === SUPER_ADMIN_ROLE;

  if (!isSuperAdmin) {
    const r = user?.roleName?.toLowerCase();
    const toAdminPortal = r?.includes('admin') || r?.includes('enterprise manager');
    return <Navigate to={toAdminPortal ? '/admin-portal/dashboard' : '/dashboard'} replace state={{ error: 'Super Admin access required' }} />;
  }

  return (
    <Routes>
      <Route path="/" element={<SuperAdminDashboard />} />
      <Route path="/companies" element={<CompanyDetails />} />
      <Route path="/create" element={<AddCompany />} />
      <Route path="/analytics" element={<SuperAdminAnalytics />} />
      <Route path="/settings" element={<SuperAdminSettings />} />
      <Route path="*" element={<Navigate to="/superadmin" replace />} />
    </Routes>
  );
};

export default SuperAdminRouter;
